import BasePaytableContainer from "../paytable/BasePaytableContainer";

export default class BaseMobilePaytablePortraitContainer extends BasePaytableContainer {
    constructor(data, displayItemData) {
        super(data, displayItemData);
    }

    init() {
        super.init();
        this.maskContainer = this.getChildAt(3);
    }

    addScrollListeners() {
        this.scrollableContainer.on('touchstart', this.onTouchStart, this);
        this.scrollableContainer.on('touchmove', this.onTouchMove, this);
        this.scrollableContainer.on('touchend', this.onTouchEnd, this);
        this.scrollableContainer.on('touchcancel', this.onTouchEnd, this);
    }

    onTouchStart(event) {
        let position = event.data.getLocalPosition(this.scrollableContainer);
        this.lastPosition = position;

    }

    onTouchMove(event) {
        if (!this.lastPosition) {
            return;
        }
        let position = event.data.getLocalPosition(this.scrollableContainer);
        this.scrollableContainer.emit('scroll', { wheelDelta: position.y - this.lastPosition.y });
        this.lastPosition = position;
    }

    onTouchEnd(event) {
        this.lastPosition = null;
    }

    resize(data) {
        this.background.height = data.height;
        this.scrollableContainer.height = data.height - 110;
        this.maskContainer.height = data.height - 110;

        this.background.y = this.background.height / 2;
        this.scrollableContainer.y = this.scrollableContainer.height / 2 + 110;
        this.maskContainer.y = this.maskContainer.height / 2 + 110;

        this.initMaskParams();

        if (this.scrollBar) {
            this.scrollBar.setData({contentHeight: this.container.height, containerHeight: this.maskHeight});

            let totalValue = Math.abs(this.container.height - this.maskHeight);
            let value = Math.abs(this.container.y - this.baseY);
            let currentValue = value / totalValue;

            this.scrollBar.value = currentValue * 100;
        }
    }
}